import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import { browser } from '../../global/index';
import styles from './ui-layout-sidebar.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UILayoutSidebar
 * @element ui-layout-sidebar
 * @classdesc Represents a class for <code>ui-layout-sidebar</code> element.
 * @example
 * <ui-layout-sidebar>
 *     <section class="frame">Sidebar content</section>
 * </ui-layout-sidebar>
 */
@Component({ tag: 'ui-layout-sidebar', styles })
export class UILayoutSidebar extends UIElement {
    /**
     * Toggle visibility of the sidebar depending on the children length.
     */
    toggleVisibility(): void {
        if (!this.children.length) {
            this.classList.add('-hidden');
        } else {
            this.classList.remove('-hidden');
        }
    }

    /**
     * @inheritDoc
     */
    override render(): void {
        this.setAttribute('role', 'complementary');
        this.toggleVisibility();
    }

    /**
     * @inheritDoc
     */
    override hydrate(): void {
        browser.desktopMedia.addListener(() => {
            this.toggleVisibility();
        });
    }
}
